import { PushSubKeys } from '../types/Core/PushSubscription'
import { getAll, patch, post } from './CommonServices/httpService'
import { Notification } from '../types/Core/Notification'

export const upsertPushSubscription = async (subKeys: PushSubKeys) => {
	await post(
		`/PushSubscriptions/Subscribe`,
		subKeys,
		'Failed to subscribe to notifications',
	)
}

export const listNotifications = async (): Promise<Notification[]> => {
	const result = await getAll<Notification[]>(
		`/Workers/Notif`,
		'Failed to list notifications',
	)
	return result.data
}
export const markNotificationAsRead = async (notificationId: number) => {
	await patch(`/Workers/Notif/${notificationId}/Read`, null, 'Failed to mark notification as read')
}
export const markAllNotificationsAsRead = async () => {
	await patch(`/Workers/Notif/ReadAll`, null, 'Failed to mark all notifications as read')
}